import { Button } from "@mui/material";

/**
 * Full-width neutral/secondary action button (Back, Cancel, etc.).
 * Theme-token based so it adapts to light/dark.
 */
function SecondaryButton({ children, sx, ...rest }) {
  return (
    <Button
      fullWidth
      variant="outlined"
      sx={{
        py: 1,
        color: "text.primary",
        borderColor: "divider",
        borderRadius: 2,
        fontWeight: 600,
        fontSize: 15,
        textTransform: "none",
        bgcolor: "background.paper",
        "&:hover": { bgcolor: "action.hover", borderColor: "divider" },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default SecondaryButton;
